export default __webpack_public_path__ + "logo-h.afd5a8362bd4a285407d.jpg";